<template>
  <modal @overlay-click="$emit('close')"
    >Check your email for a link to reset your password!
    <cta-button type="button" :solid="true" @click="$emit('close')"
      >Got it</cta-button
    >
  </modal>
</template>

<script>
import Modal from "@/components/Modal";
import CtaButton from "@/components/CtaButton";

export default {
  name: "ResetPasswordModal",
  components: {
    Modal,
    CtaButton,
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/mixins";
@import "@/style/variables.scss";
</style>
